import React, { Component } from 'react';
import { Row, Col, Pagination, Button} from 'react-bootstrap';
import PublicEvents from '../components/pubevent/PublicEvents';
import '../css/style.css';
import '../components/Home.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Search2 from '../components/search/Search2';
import { getURL } from '../backend/Backend';
import PublicEventShowItem from '../components/pubevent/PublicEventShowItem';
import CreateEventWidget from '../components/event/CreateEventWidget';
import CreatePublicEventWidget from '../components/pubevent/CreatePublicEventWidget';
import EventResults from '../components/event/EventResults';
import { translate } from "react-i18next";
import AuthenticationService from '../backend/AuthenticationService';
import { Link } from 'react-router-dom';



class SearchLayout extends Component {

  constructor(props) {
    super(props);
    this.searchEvents = this.searchEvents.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.goBack = this.goBack.bind(this);
    this.onSelectTab = this.onSelectTab.bind(this);


    this.state = {
      events: [],
      selected: '',
      activePage: 1,
      totalPages: 0,
      criteria: '',
      showResult: false,
      tabindex: 0
    };
  }

  async componentDidMount() {
    console.log("SearchLayout.....");
    if (!(!this.state.showResult && this.props.children)) {
      console.log("SearchLayout.....2");
      let c = { 'eventCategory': 'ALL' };

      this.searchEvents(c, 1);
    }
  }




  async pageChanged(e) {
    this.searchEvents(this.state.criteria, e.target.text);
  }

  async searchEvents(criteria, page) {

    if (!page) {
      return;
    }
    if ("<" === page) {
      page = --this.state.activePage;
    }
    if (">" === page) {
      page = ++this.state.activePage;
    }

    let isPublicEvent = this.checkPublicEvent(criteria);
    let searchService = isPublicEvent ? 'p-events' : 'events';
    console.log("criteria2:" + JSON.stringify(criteria) + '/ ' + isPublicEvent + "/" + searchService);

    let converted = criteria.eventCategory ? criteria.eventCategory : '';
    converted += "--";
    converted += criteria.subCategory ? criteria.subCategory : '';
    converted += "--";
    converted += criteria.city ? criteria.city : '';
    converted += "--";
    converted += criteria.startDate ? criteria.startDate : '';

    const response = await fetch(getURL(`${searchService}/search/${converted}/${page - 1}`));
    const json = await response.json();
    console.log("received json: " + JSON.stringify(json));
    let oldState = this.state;
    this.setState({
      ...oldState,
      events: json.content,
      selected: '',
      totalPages: json.totalPages,
      activePage: page,
      criteria: criteria,
      showResult: true
    });

  }


  checkPublicEvent(criteria) {
    return (this.props.searchType === 'PUBLIC' || (criteria && criteria.searchType === 'PUBLIC')) || (!this.props.searchType && (!criteria || !criteria.searchType)) ? true : false;
  }

  selectItem(e) {
    let oldState = this.state;

    this.setState({
      ...oldState,
      selected: e.id
    })
  }

  goBack() {
    let oldState = this.state;

    this.setState({
      ...oldState,
      selected: ''
    })
  }

  onSelectTab(tabindex) {
    let oldState = this.state;
    this.setState({
      ...oldState,
      tabindex: tabindex
    });
  }



  render() {
    const { t } = this.props;
    let user = AuthenticationService.getLoggedUser();
    let isPublicEvent = this.checkPublicEvent(null);
    let createLink = isPublicEvent ? 'pubEventAdd':'eventAdd';
    let createLabel = isPublicEvent ? 'CreatePublicEvent':'ActivityErstellen';
    let cssClass = isPublicEvent ? 'primary':'success';
    if (!this.state.showResult && this.props.children) {
      return (
        <div id="container">
          <div id="header"><Header eventKey={this.props.eventKey} bg={this.props.bg} bgStrong={this.props.bgStrong} /></div>
          <div id="body" >
            <Row className={"mt-3"}>
            <Col xl={2} xs={12} >
           
           <Row>
             <Col>
             {isPublicEvent ?
             <CreatePublicEventWidget />
             :
             <CreateEventWidget />
            }
               
             </Col>
           </Row>
         </Col>
              
              <Col xl={8} xs={12}  >
             
                {this.props.title ?
                  <div>
                    <Row className="mt-2 mb-2">
                      <Col >
                        <h3 className={(isPublicEvent ? "text-primary" : "text-success") + " ml-2 mt-2 mb-2"}>{this.props.title }</h3>
                      </Col>
                    </Row>
                    <Row >
                      <Col >{this.props.children}</Col>
                    </Row>
                  </div>
                  :
                  <Row>
                    <Col>
                      {this.props.children}
                    </Col>
                  </Row>
                }




              </Col>
              <Col xl={2} xs={6} >
                <p>Hier kommt werbung XXX...</p>
              </Col>
            </Row>

          </div>
          <div id="footer"><Footer /></div>
        </div>
      );
    }

    return (
      <div id="container">
        <div id="header"><Header eventKey={this.props.eventKey} bg={this.props.bg} bgStrong={this.props.bgStrong} /></div>
        <div id="body" >
          <Row className="justify-content-md-center mt-2" >
            <Col xl={2} xs={12} >
           
              <Row>
                <Col>
                {isPublicEvent ?
                <CreatePublicEventWidget />
                :
                <CreateEventWidget />
               }
                  
                </Col>
              </Row>
           

            </Col>
            <Col xl={8} xs={12}  >
            <Row   >
                <Col  >
                  <Search2 searchEvents={this.searchEvents} searchType={this.props.searchType} />
                </Col>
              </Row>
             
            {this.props.title ?
                
                    <Row className="mt-2 mb-2 ml-1">
                      <Col >
                        <h2 className={ "text-black  mt-2 mb-2"}>{this.props.title }</h2>
                      </Col>
                      <Col>
                      <Link to={`/${createLink}`}  >
                                <Button variant={cssClass}  size="sm" className="float-right">
                                <i className=" fa fa-plus  ml-2 mr-1 " ></i>{t(createLabel)}
                                </Button></Link>
                      </Col>
                    </Row>
                    :
                    ''
            }


              <Row className="ml-1">
                {this.state.selected ?
                  <PublicEventShowItem id={this.state.selected} goBack={this.goBack} />

                  :
                  <div>
                    {isPublicEvent ?
                      <PublicEvents events={this.state.events} selectItem={this.selectItem} />
                      :
                      <EventResults events={this.state.events} />
                    }

                    <Pagination onClick={this.pageChanged}>
                      {this.state.activePage > 1 ?
                        <Pagination.Item>{'<'}</Pagination.Item>
                        : ""
                      }

                      {[...Array(this.state.totalPages).keys()].map(i => {
                        return <Pagination.Item active={(i + 1) === this.state.activePage} key={i} >{i + 1}</Pagination.Item>
                      })
                      }
                      {this.state.activePage < this.state.totalPages ?
                        <Pagination.Item>{'>'}</Pagination.Item>
                        : ""
                      }

                    </Pagination>
                  </div>
                }
              </Row>
            </Col>


            <Col xl={2} xs={6} >
              <p>Hier kommt werbung XXX2...</p>
            </Col>
          </Row>

        </div>
        <div id="footer"><Footer /></div>
      </div>
    );
  }

}

export default translate("translations")(SearchLayout);